import { jsPDF } from "jspdf";
import banner1 from "../../../Assets/ptags/banner.jpg";

export const generatePDF3 = (pages = 1, bannerImg) => {
  const width = 1056;  // Portrait width
  const height = 1632; // Portrait height
  const doc = new jsPDF({
    orientation: "portrait", // switched from landscape
    unit: "pt",
    format: [width, height],
  });

  const sectionWidth = width / 2;
  const sectionHeight = height / 2;
  const bannerImgWidth = sectionWidth - 5;
  const bannerImgHeight = 94;

  for (let p = 0; p < pages; p++) {
    if (p > 0) doc.addPage();

    for (let i = 0; i < 4; i++) {
      const xPos = (i % 2) * sectionWidth + 2.5;
      const yPos = Math.floor(i / 2) * sectionHeight + 2.5;

      // Draw banner
      doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

      // Draw rectangle/frame below banner
      const frameX = xPos + 2.5;
      const frameY = yPos + bannerImgHeight + 4.8;
      const frameW = sectionWidth - 10;
      const frameH = sectionHeight - (bannerImgHeight + 12);

      doc.setLineWidth(2);
      doc.setDrawColor(71, 74, 119);
      doc.rect(frameX, frameY, frameW, frameH, 'S');
    }

    // Dashed lines for quadrant reference
    doc.setLineDashPattern([10, 5], 0);
    doc.setDrawColor(0);
    doc.setLineWidth(1);
    doc.line(0, height / 2, width, height / 2); // Horizontal center
    doc.line(width / 2, 0, width / 2, height); // Vertical center
  }

  // Save the PDF
   doc.save("portraite-2x2.pdf");
};
